import theme from './themeImport'

const device = (value: string) => `@media screen and (min-width: ${value})`

const breakPoint = {
    tablet: device(theme.breakpoints[0]),
    desktop: device(theme.breakpoints[2]),
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    custom: (value: string) => device(value),
}

export default breakPoint
